import { ChangeDetectionStrategy, Component, ViewChild, inject, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule, DrawerComponent, MaskService } from '../../../../lib';
import { RoomByRoomCommon } from '../../common';
import { CalculationBase } from '../../models';

@Component({
    selector: 'ca-rbr-calculation-base',
    templateUrl: './calculation-base.component.html',
    styleUrls: ['./calculation-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, ComponentsModule, ReactiveFormsModule, MatInputModule]
})
export class CalculationBaseComponent {
    headerText = input<string>('RBR.CALCULATION_BASE.TITLE');
    calculationBase = input.required<CalculationBase>();
    confirm = output<CalculationBase>();
    maskService = inject(MaskService);
    mask = this.maskService.getNumericMask({ separatorLimit: '1000', numberOfDecimals: '2', suffix: 'MEASUREMENT_UNITS.M2' });

    @ViewChild('drawer') drawer!: DrawerComponent;

    readonly form = new FormGroup({
        totalLivingArea: new FormControl<number>(0, {
            validators: [RoomByRoomCommon.requiredValidTotalLivingArea],
            nonNullable: true
        }),
        includeTotalBuilding: new FormControl<boolean>(false, { nonNullable: true })
    });

    hasError(controlName: string, errorKey: string): boolean {
        const control = this.form.get(controlName);

        if (!control) {
            return false;
        }

        return control.hasError(errorKey) && (control.touched || control.dirty);
    }

    openDrawer(): void {
        const value = this.calculationBase();

        this.form.reset({
            totalLivingArea: value.totalLivingArea,
            includeTotalBuilding: value.includeTotalBuilding
        });
        this.form.markAsPristine();
        this.form.markAsUntouched();

        this.drawer.open();
    }

    onCancel(): void {
        this.drawer.close();
    }

    onConfirm(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const payload = this.form.getRawValue();

        this.confirm.emit(payload);
        this.drawer.close();
    }
}
